import AppDirection from "./components/common/AppDirection/AppDirection";
import Header from "./components/layouts/Header/Header";
import Footer from "./components/layouts/Footer/Footer";
import "./App.css";
import "./styles/rtl.css";
import Home from "./pages/HomePage/HomePage";
import VehiclesPage from "./pages/VehiclesPage/VehiclesPage";
import VehicleDetailsPage from "./pages/VehicleDetailsPage/VehicleDetailsPage";
import SparePartsPage from "./pages/SparePartsPage/SparePartsPage";
import OffersPage from './pages/OffersPage/OffersPage'
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/common/ScrollToTop/ScrollToTop";
import LocationPage from "./pages/LocationPage/LocationPage";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import ServicesPage from "./pages/ServicesPage/ServicesPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";
import TermsConditionsPage from "./pages/TermsConditionsPage/TermsConditionsPage";
import FAQPage from "./pages/FAQPage/FAQPage";

function App() {
  return (
    <div className="app">
      <AppDirection />
      <Header />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vehicles" element={<VehiclesPage />} />
          <Route path="/vehicles/:vehicleId" element={<VehicleDetailsPage />} />
          <Route path="/spare-parts" element={<SparePartsPage />} />
          <Route path="/offers" element={<OffersPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/locations" element={<LocationPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
